<h2 mat-dialog-title class="offline-download__title">
  {{ 'offlineDownload.title' | translate }}
  @if (data.workOrderNo) {
    <span class="offline-download__work-order-no">{{ data.workOrderNo }}</span>
  }
</h2>

<div class="offline-download__header">
  <div class="offline-download__row offline-download__row--metadata">
    <mat-checkbox [checked]="true" [disabled]="true">
      {{ 'offlineDownload.metadata' | translate }}
    </mat-checkbox>
    <ng-container *ngTemplateOutlet="statusTemplate; context: { $implicit: state.metadata }"></ng-container>
  </div>

  <div class="offline-download__options">
    <span class="offline-download__options-heading">{{ 'offlineDownload.options.files' | translate }}</span>
    <mat-checkbox
      [checked]="allFilesSelected"
      [indeterminate]="!allFilesSelected && someFilesSelected"
      [disabled]="state.running"
      (change)="toggleAllFiles($event.checked)"
    >
      {{ 'offlineDownload.options.allFiles' | translate }}
    </mat-checkbox>
    @for (option of categoryOptions; track option.category) {
      <mat-checkbox
        [checked]="categories.has(option.category)"
        [disabled]="state.running"
        (change)="toggleCategory(option.category, $event.checked)"
      >
        {{ option.labelKey | translate }}
      </mat-checkbox>
    }
  </div>

  @if (!isOnline) {
    <p class="offline-download__message">{{ 'offlineDownload.offline' | translate }}</p>
  }
</div>

<mat-dialog-content class="offline-download">
  @if (loading) {
    <mat-spinner diameter="25"></mat-spinner>
  } @else if (loadFailed) {
    <p class="offline-download__message">{{ 'offlineDownload.loadFailed' | translate }}</p>
  } @else if (rows.length === 0) {
    <p class="offline-download__message">{{ 'offlineDownload.noDocuments' | translate }}</p>
  } @else {
    <ul class="offline-download__list">
      @for (row of rows; track row.document.id) {
        <li
          class="offline-download__row offline-download__row--document"
          [class.offline-download__row--disabled]="isRowDisabled(row)"
          (click)="toggleRow(row)"
        >
          <mat-checkbox
            [checked]="isSelected(row)"
            [disabled]="isRowDisabled(row)"
            (click)="$event.stopPropagation()"
            (change)="toggleDocument(row, $event.checked)"
          ></mat-checkbox>
          <span class="offline-download__badge">{{ badgeKey(row) | translate }}</span>
          <span class="offline-download__name" [attr.title]="row.document.name || row.document.filename">{{
            row.document.name || row.document.filename
          }}</span>
          <span class="offline-download__size">{{ fileSize(row) }}</span>
          <ng-container *ngTemplateOutlet="statusTemplate; context: { $implicit: statusOf(row) }"></ng-container>
        </li>
      }
    </ul>
  }
</mat-dialog-content>

<mat-dialog-actions class="offline-download__actions">
  <span
    class="offline-download__total"
    [class.offline-download__total--warning]="downloadPhase === 'doneWithFailures' || downloadPhase === 'failed'"
  >
    @switch (downloadPhase) {
      @case ('running') {
        {{ 'offlineDownload.progress.running' | translate: progress }}
      }
      @case ('done') {
        {{ 'offlineDownload.progress.done' | translate }}
      }
      @case ('doneWithFailures') {
        <mat-icon class="offline-download__total-icon">warning</mat-icon>
        {{ 'offlineDownload.progress.doneWithFailures' | translate: progress }}
      }
      @case ('failed') {
        <mat-icon class="offline-download__total-icon">warning</mat-icon>
        {{ 'offlineDownload.progress.failed' | translate }}
      }
      @default {
        {{ 'offlineDownload.total' | translate: { count: selectedRows.length, size: selectedKnownSize } }}
        @if (selectedUnknownSizeCount > 0) {
          {{ 'offlineDownload.unknownSize' | translate: { count: selectedUnknownSizeCount } }}
        }
      }
    }
  </span>
  <button mat-button (click)="close()">{{ 'offlineDownload.close' | translate }}</button>
  @if (!selectionAlreadyDownloaded) {
    <button mat-flat-button color="primary" [disabled]="!canDownload" (click)="download()">
      {{ 'offlineDownload.download' | translate }}
    </button>
  }
</mat-dialog-actions>

<ng-template #statusTemplate let-status>
  <span
    class="offline-download__status"
    [attr.title]="status ? ('offlineDownload.status.' + status | translate) : null"
  >
    @if (status === 'downloading') {
      <mat-spinner diameter="18"></mat-spinner>
    } @else if (status) {
      <mat-icon [ngClass]="'offline-download__status-icon--' + status">{{ statusIcon(status) }}</mat-icon>
    }
  </span>
</ng-template>
